import { useMutation as useDismissConductorComponentMutation } from "@faire/web-api/api/conductor/dismiss-component/post-hooks";
import { IDismissConductorComponentRequest } from "@faire/web-api/indigofair/data/IDismissConductorComponentRequest";
import { useCallback } from "react";

/**
 * In addition to the functions below, it is also necessary to return null on the respective component on the client
 * side after dimissing it. The functions below only updates the backend state for next render.
 * @returns 2 functions to dismiss Conductor components
 * - `dismissSDUIConductorComponent`: To be used within SDUI components
 * - `dismissConductorComponent`: To be used in standalone Conductor components
 */
export const useConductorComponentDismissal = () => {
  const { mutate: dismissConductorComponentMutation } =
    useDismissConductorComponentMutation();

  const dismissSDUIConductorComponent = useCallback(
    (token: string) => () => {
      dismissConductorComponentMutation([
        IDismissConductorComponentRequest.build({
          component_token: token,
        }),
      ]);
    },
    [dismissConductorComponentMutation]
  );

  const dismissConductorComponent = useCallback(
    (token: string) => {
      dismissConductorComponentMutation([
        IDismissConductorComponentRequest.build({
          component_token: token,
        }),
      ]);
    },
    [dismissConductorComponentMutation]
  );

  return {
    dismissConductorComponent,
    dismissSDUIConductorComponent,
  };
};
